import templateUrl from "emun.invoice/payment-history.htm";
import controller from "emun.invoice/payment-history.controller";

export default {
  bindings: {
    retailerId: "@"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
